import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { InputGroup, InputGroupAddon, Button, Input, Alert } from 'reactstrap';
//import { isApartamentoValid, isDataFuturaValid } from '../../utils/validation';

import actions from './actions';
//import  { PERFIS_CONHECIDOS } from './constants';

class FormularioAcesso extends Component {
  constructor(props) {
    super(props);

    this.state = {
      success: false,
      fetching: false,
      errors: [],
      data: {
        local: '',
        categoria: '',
        observacao: ''
      }
    };

    this.solicita = this.solicita.bind(this);
  }

  componentDidMount() {
    const { onLoadLocais, onLoadCategorias } = this.props.actions;

    onLoadLocais();
    onLoadCategorias();
  }

  handleOption = e => {
    this.setState({
      success: false,
      data: {
        ...this.state.data,
        [e.target.name]: parseInt(Array.from(e.target.options)
          .find(v => v.selected).value, 10)
      }
    });
  }

  handle = (field, sanitize = /[^\d\w\sáéíóúàâêôãõç]+/gi) => (e) => {
    let value = e.target.value;
    if (e.target.valueAsNumber || !e.target.value) {
      value = e.target.value;
    }

    this.setState(state => ({
      data: {
        ...state.data,
        [field]: value
          .replace(/^\s+|\s+(?=\s$|\s)/g, '')
          .replace(sanitize, '')
      }
    }));
  };

  contains = (value, list) => {
    return list.some(item => item.id === value || this.contains(value, item.options));
  }

  isValid = () => {
    let { local, categoria } = this.state.data;
    let { locais, categorias } = this.props.value;

    let errors = [];
    if (!local || !this.contains(local, locais.result)) {
      errors.push("Local é obrigatório.");
    }
    if (!categoria || !this.contains(categoria, categorias.result)) {
      errors.push("Categoria é obrigatório.");
    }

    return errors;
  }

  validate = () => {
    let errors = this.isValid();
    if (errors.length || this.state.errors.length) {
      this.setState({
        errors
      });
    }

    return !errors.length;
  }

  solicita(e) {
    e.preventDefault();

    if (this.validate()) {
      this.setState({
        fetching: true,
        success: false
      });

      this.props.actions.onSaveRelato(this.state.data)
      .then(() => {
        this.setState({
          fetching: false,
          success: true,
          data: {
            local: '',
            categoria: '',
            observacao: ''
          }
        });
      });
    }
  }

  render() {
    let { data, success, fetching, errors } = this.state;

    let { locais, categorias } = this.props.value;

    const loopOpt = (v, i) => (v.options.length?v.options.map(loopOpt):
      <option key={i} value={v.id}>» {v.nome}</option>
    );

    const loop = (v, i) => (<optgroup key={i} label={v.nome}>
        {v.options.map(loopOpt)}
      </optgroup>
    );

    return (
      <form onSubmit={this.solicita}>
        <InputGroup>
          <InputGroupAddon
            addonType="prepend"
            className="d-none d-sm-block col-sm-4 col-md-3 col-xl-2"
          >Local
          </InputGroupAddon>
          <Input
            disabled={fetching}
            onChange={this.handleOption}
            type="select"
            size="8"
            name="local"
            title="Local"
            placeholder="Local"
            required
            value={data.local}
          >
            <option className="d-sm-none" default disabled value="">Local</option>
            {locais.result.map(loop)}
          </Input>
        </InputGroup>
        <InputGroup>
          <InputGroupAddon
            addonType="prepend"
            className="d-none d-sm-block col-sm-4 col-md-3 col-xl-2"
          >Categoria
          </InputGroupAddon>
          <Input
            disabled={fetching}
            onChange={this.handleOption}
            type="select"
            size="8"
            name="categoria"
            title="Categoria"
            placeholder="Categoria"
            required
            value={data.categoria}
          >
            <option className="d-sm-none" default disabled value="">Categoria</option>
            {categorias.result.map(loop)}
          </Input>
        </InputGroup>
        <InputGroup>
          <InputGroupAddon
            addonType="prepend"
            className="d-none d-sm-block col-sm-4 col-md-3 col-xl-2"
          >
            Observação
          </InputGroupAddon>
          <Input
            disabled={fetching}
            placeholder="Informe detalhes que achar relevante"
            type="textarea"
            value={data.observacao}
            onChange={this.handle('observacao')}
          />
          <InputGroupAddon addonType="append">
            <Button type="submit" color="success" title="Registrar!" disabled={fetching || !!this.isValid().length}>
              <span className="fa fa-check" />{' '}
              <span className="d-none d-md-inline-block">Registrar!</span>
            </Button>
          </InputGroupAddon>
        </InputGroup>
        <br />
        <Alert isOpen={success}>Registro realizado com sucesso.</Alert>
        {!success && errors.map((v, i) => (<Alert color="danger" key={i}>{v}</Alert>))}
      </form>
    );
  }
}

let mapStateToProps = ({ problema }) => ({
  value: problema
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormularioAcesso);



// WEBPACK FOOTER //
// ./src/modules/problema/Cadastro.js